export const sortCriteria = [
  { field: "Alfabetisk (A - Å)", order: "asc", key: "title" },
  { field: "Alfabetisk (Å - A)", order: "desc", key: "title" },
  { field: "Pris (lav - høy)", order: "asc", key: "price" },
  { field: "Pris (høy - lav)", order: "desc", key: "price" },
];
export const selectedSort = $state({ sort: sortCriteria[0] });
